/**
 * Thank-you when a Mitgestalten suggestion ships.
 * Same sentence in chat, push, and the email fallback.
 * Keep in sync with server/lib/shippedIdeaMessage.js (Render cannot import this file).
 *
 * @param {{ title?: string, shippedNote?: string|null }} params
 */
export function buildShippedIdeaMessage({ title, shippedNote }) {
  const name = String(title || "").trim();
  const note = String(shippedNote || "").trim();
  if (note) {
    return `Danke für deinen Vorschlag — «${name}»: ${note}`;
  }
  return `Danke für deinen Vorschlag — «${name}» ist umgesetzt.`;
}
